//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["license","contextName"],"Reserve",{},2,0],[["license","contextName"],"Release",{},2,0],[["contextName"],"ReleaseAll",{},1,0],[["contextName","nLicenses"],"GetReservedLicenses",{R_:{licenses:""}},1,0],[["nLicenseBundles"],"GetBundlesSelected",{R_:{licenseBundles:""}},0,0],[["bundles"],"SetBundlesForUse",{},1,0],[["nBundles"],"GetBundlesUsed",{R_:{licenses:""}},0,0],[["bundle_name","activeLicensesCount"],"GetActiveLicensesInABundle",{R_:{activeLicenses:""}},1,0],[["license_name"],"CheckPresence",{R_:{license_present:''}},1,0],[["license"],"IsCheckedOut",{R_:{isReserved:''}},1,0]],[]];
SPLM.LicenseManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.LicenseManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LicenseManager.LicenseBundle = class{
    constructor(numUsing,bundle_name){
        this.numUsing=numUsing;this.bundle_name=bundle_name;}
    get Numusing(){return this.numUsing}
    set Numusing(val){this.numUsing = val}
    get BundleName(){return this.bundle_name}
    set BundleName(val){this.bundle_name = val}
};

export default SPLM;